import React from "react";
import { motion } from "framer-motion";
import { Overline } from "./Reveal";

export function PageHero({ overline, title, subtitle, image, accent = "signal", children, testId }) {
  return (
    <section className="relative overflow-hidden grain pt-32 pb-16 md:pt-40 md:pb-20" data-testid={testId || "page-hero"}>
      <div className="absolute inset-0">
        {image && (
          <img src={image} alt="" className="w-full h-full object-cover opacity-25" />
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900/80 via-navy-900/90 to-navy-900" />
        <div
          className="absolute inset-0"
          style={{
            background:
              accent === "gold"
                ? "radial-gradient(ellipse at top left, rgba(212,175,55,0.14), transparent 55%)"
                : accent === "health"
                ? "radial-gradient(ellipse at top left, rgba(16,185,129,0.14), transparent 55%)"
                : "radial-gradient(ellipse at top left, rgba(0,85,255,0.16), transparent 55%)",
          }}
        />
      </div>
      <div className="container-x relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl"
        >
          {overline && <Overline color={accent}>{overline}</Overline>}
          <h1 className="mt-4 font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-base sm:text-lg text-white/65 leading-relaxed">{subtitle}</p>
          )}
          {children && <div className="mt-8">{children}</div>}
        </motion.div>
      </div>
    </section>
  );
}

export default PageHero;
